import { Box, Grid } from "@mui/material";
import { forwardRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ControlledInput } from "../forms/input/ControlledInput";
import moment from "moment";

export default function SingleInputDateRangePicker({ control, errors, setValue, getValues }: any) {

    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());

    const CustomFromDatePicker = forwardRef(({ value, onClick }: any, ref: any) => {
        return (<Box onClick={onClick} ref={ref}>
            <ControlledInput width={'120px'} name="fromDate" control={control} errors={errors} label="From Date" size={'small'} />
        </Box>
        )
    });
    const CustomToDatePicker = forwardRef(({ value, onClick }: any, ref: any) => {
        return (<Box onClick={onClick} ref={ref}>
            <ControlledInput width={'120px'} name="toDate" control={control} errors={errors} label="To Date" size={'small'} />
        </Box>
        )
    });

    return (
        <Grid item>
            <Box sx={{ position: 'relative', display: 'flex', width: '260px', justifyContent: 'space-between', alignItems: 'center' }} >
                <DatePicker
                    selected={startDate}
                    onChange={(date: any) => {
                        setStartDate(date);
                        setValue("fromDate", moment(date).format('YYYY-MM-DD'));
                    }}

                    selectsStart
                    startDate={startDate}
                    endDate={endDate}
                    customInput={<CustomFromDatePicker />}
                />
                -
                <DatePicker
                    selected={endDate}
                    onChange={(date: any) => {
                        setValue("toDate", moment(date).format('YYYY-MM-DD'));
                        setEndDate(date)
                    }}

                    selectsEnd
                    startDate={startDate}
                    endDate={endDate}
                    minDate={startDate}
                    customInput={<CustomToDatePicker />}
                />
            </Box>
        </Grid>
    );
}